module.exports = __webpack_public_path__ + "static/media/mail-2.31556cf8.svg";